/**
 * Helper to trigger file upload dialog in Archetypes forms.
 * This is needed, because the file upload button comes with no <label/>,
 * which otherwise would connect the button with the "file" input field.
 */

import $ from 'jquery';

import App from 'libs/app';

App.registerUiComponent('fileupload-button', () => {
    $('.fileupload .button')
        .off('click.fileupload-button')
        .on('click.fileupload-button', function (event) {
            $(this).parent().find('input').click();
            return event.preventDefault();
        });
});
